import { ref } from "vue";
import { addUser, destroyUser, getAllUsers, userSearch , editUser} from "@/api/users";


const state = {
    users:ref([]),

};

const actions = {
    async fetchUsers({commit} , page){
        try{
            const response = await getAllUsers(page);
            console.log(response);
            commit('SET_USERS' , response.users);
        }catch(e){
            throw new Error(e);
        }
    },
    async searchUsers({commit} , data){
        try{
            const response = await userSearch(data);
            console.log(response);
            commit('SET_USERS' , response.users);
        }catch(e){
            throw new Error(e);
        }
    },
    async addNewUser({commit} , data){
        try{
            const response = await addUser(data);
            console.log(response);
            commit('ADD_USER' , response);
        }catch(e){
            throw new Error(e);
        }
    },
    async deleteUser({commit} , id){
        try{
            const response = await destroyUser(id);
            commit('DELETE_USER' , id);
        }catch(e){
            throw new Error(e);
        }
    },
    async updateUser({commit} , user){
        try{
            const response = await editUser(user);
            //commit('UPDATE_USER' , response.data.user);
        }catch(e){
            throw new Error(e);
        }
    }
}

const mutations = {
    DELETE_USER(state , id){
        state.users.data = state.users.data.filter(user => user.id !== id);
    },
    SET_LISTS(state, lists){
        state.lists = lists;
    },
    SET_USERS(state , users){
        state.users = users;
        state.users.data = state.users.data.map(user => ({
            ...user,
            is_user_show:false,
            is_edit_active:false,
            is_filter_opens:false,
        }))
    },
    ADD_USER(state , user){
        state.users.data.unshift({
            ...user,
            is_user_show:false,
            is_edit_active:false,
        });
    }
};
const getters = {
    getUsers: (state) => state.users,
};

export default {
    namespaced: true,
    state , 
    getters,
    mutations,
    actions
};